import React from 'react';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { useTimeStamp } from '../../../hooks/useTimeStamp';

const WidgetSearchResultVer = (props) => {
  const { tveeImgUrl } = props;
  const list = props.childProps.payload.list;
  const param = props.childProps.payload.param;
  const preText = props.childProps.state.prevMessage;

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };

  const _goTimeline = (contentSerial, title) => {
    props.childProps.actionProvider._timeline(contentSerial, title);
  };
  const _goItem = (contentSerial) => {
    const { history } = props;
    history.push(`/items/${contentSerial}`);
  };
  const _goSearch = () => {
    window.open(
      `https://www.aniplustv.com/search?st==${encodeURIComponent(param)}&g=n`,
      '',
      ''
    );
  };
  return (
    <>
      <div>
        {/* <div className="widget-containter-title" onClick={_goSearch}>
          <h1>[{param}] 검색 결과 더보기</h1>
        </div> */}
        <div className="widget-container-ver">
          <div>
            <ul className="widget-content-list-ver">
              {list.map((item) => (
                <li key={item.contentSerial}>
                  <img
                    src={
                      tveeImgUrl + '/images/tvee-admin/content/' + item.imageL
                    }
                    alt={item.title}
                  />
                  <div className="right">
                    <div className="title">
                      <a>{item.title}</a>
                    </div>
                    <div className="genre">{item.genreName}</div>
                    <div className="subTitle">{item.subTitle}</div>
                    {item.regDate && (
                      <div className="date">
                        {useTimeStamp(item.regDate)}
                        {/* {moment(item.regDate).format('YYYY.MM.DD hh:mm')} */}
                      </div>
                    )}
                  </div>
                  <div className="btn">
                    <div
                      className="prev"
                      onClick={() => _goItem(item.contentSerial)}
                    >
                      작품정보
                    </div>
                    <div
                      className="timeline"
                      onClick={() =>
                        _goTimeline(item.contentSerial, item.title)
                      }
                    >
                      편성정보
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="widget-time">{props.childProps.payload.writetime}</div>
        <div className="prev-chat-container">
          <div className="prev-contaner">
            {preText && (
              <div onClick={_prev} className="prev">
                <img src="/img/chatbot/icon_prev.png" />
                이전 단계로 이동
              </div>
            )}
            <div onClick={_goHome} className="prev">
              <img src="/img/chatbot/icon_home.png" />
              처음으로
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default shopContext(withRouter(WidgetSearchResultVer));
